import {Avatar, Box, Button, Chip, Paper, Typography} from "@mui/material";
import {StorefrontOutlined} from "@mui/icons-material";

export default function WorkspaceHeader({title, companyName, typeLabel, logoUrl, disabled, actions = []}) {
    return <Paper component="header" variant="outlined" sx={{p: {xs: 2, md: 2.5}, borderRadius: 2, mb: 2.5}}>
        <Box sx={{display: "flex", alignItems: "center", gap: 2, minWidth: 0}}>
            <Avatar src={logoUrl || undefined} variant="rounded" sx={{width: 60, height: 60, flexShrink: 0, bgcolor: "primary.main"}}>
                <StorefrontOutlined/>
            </Avatar>
            <Box sx={{minWidth: 0, flex: 1}}>
                <Typography component="h1" variant="h5" fontWeight={600}>{title}</Typography>
                <Box sx={{display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1, mt: 0.5}}>
                    <Typography variant="body2" color="text.secondary">{companyName}</Typography>
                    <Chip size="small" variant="outlined" label={typeLabel}/>
                </Box>
            </Box>
        </Box>
        {actions.length > 0 && <Box sx={{display: "flex", flexWrap: "wrap", gap: 1, mt: 2}}>
            {actions.map(({label, icon, onClick}, index) => <Button key={label} disabled={disabled} startIcon={icon}
                onClick={onClick} variant={index === 0 ? "contained" : "outlined"} sx={{flex: {xs: "1 1 100%", sm: "0 1 auto"}}}>
                {label}
            </Button>)}
        </Box>}
    </Paper>;
}
